import { render, staticRenderFns } from "./PdMobileSticky.vue?vue&type=template&id=18233ae8"
import script from "./PdMobileSticky.vue?vue&type=script&lang=js"
export * from "./PdMobileSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports